import { Currency } from '@mobi/utils/money'

/** Kambi currency is represented by integers - 1000 times dollar value
 *  ie. 3570 is $3.57 (3570 / 1000)
 */
export const formatKambiCurrencyToDollarDecimal = (amount: number) => {
  return new Currency(amount, { dollarMultiplier: 1_000 }).value
}

export const formatDollarDecimalToThousandMultplier = (amount: number) => {
  return Math.floor(amount * 1_000)
}
